import React, { createContext, useContext } from 'react';

/**
 * Context for sharing leads-related state and handlers
 */
const LeadsContext = createContext();

/**
 * Custom hook to use the leads context
 */
export const useLeadsContext = () => {
  const context = useContext(LeadsContext);
  if (!context) {
    throw new Error('useLeadsContext must be used within a LeadsProvider');
  }
  return context;
};

/**
 * Provider component for leads context
 */
export const LeadsProvider = ({ children, value }) => {
  return (
    <LeadsContext.Provider value={value}>
      {children}
    </LeadsContext.Provider>
  );
};

/**
 * HOC to inject leads context as props
 */
export const withLeadsContext = (Component) => {
  return (props) => {
    const leadsContext = useLeadsContext();
    return <Component {...props} {...leadsContext} />;
  };
};